import request from './request';

// 通用的异步导出任务
export function addTask(data) {
  return request({
    // TODO HERE
    // 这里之前写的是/item/addTask，看代码应该是改成/ExportTask/addTask ? 未确定
    // url: '/item/addTask',
    url: '/ExportTask/addTask',
    method: 'get',
    params: data,
  });
}

/**
 * 获取导出任务列表（旧版通用接口，baseURL 为 /api）
 * 与 addTask 配对，对应后端 /ExportTask/exportTaskList
 * @param {Object} data 请求参数：type/pageSize/pageNum 等
 * @returns Promise
 */
export function getExportTaskList(data) {
  return request({
    url: '/ExportTask/exportTaskList',
    method: 'get',
    params: data,
  });
}

/**
 * 获取导出任务列表（资金中心专用接口，baseURL 为 /fundapi）
 * 与 getExportTaskList 区分：本接口走资金中心 fundapi 模块
 * 对应后端 /fundapi/ExportTask/exportTaskList
 * @param {Object} data 请求参数：type/pageSize/pageNum 等
 * @returns Promise
 */
export function getFundExportTaskList(data) {
  return request({
    url: '/exportTask/exportTaskList',
    method: 'get',
    params: data,
    apiModule: 'fund',
  });
}


// 字典数据
export function handlerPublicGetDictData(data) {
  return request({
    url: '/dict/list',
    method: 'get',
    params: data,
  });
}

export function getAdminUserRoleAdmin(data) {
  return request({
    url: '/AdminUser/getRoleAdmin',
    method: 'get',
    params: data,
  });
}

export function handlerCreateRefundRecord(data) {
  return request({
    apiModule:'fund',
    url: '/DataCenter/createRefundRecord',
    method: 'post',
    data: data,
  });
}

